import { render, staticRenderFns } from "./AvbScore.vue?vue&type=template&id=7a47b8a3&scoped=true"
import script from "./AvbScore.vue?vue&type=script&lang=js"
export * from "./AvbScore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a47b8a3",
  null
  
)

export default component.exports